import React from 'react';
import { Block } from '../../types';
import { TableBlockRenderer } from './TableBlockRenderer';
import { ChartBlockRenderer } from './ChartBlockRenderer';
import { ShipmentCardRenderer } from './ShipmentCardRenderer';
import { ShareLinkRenderer } from './ShareLinkRenderer';
import { ExportBlockRenderer } from './ExportBlockRenderer';

interface BlockListProps {
  blocks?: Block[];
}

export const BlockList: React.FC<BlockListProps> = React.memo(({ blocks }) => {
  if (!blocks || blocks.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 mt-2 w-full">
      {blocks.map((block, index) => {
        const key = `block-${block.kind}-${index}`;

        switch (block.kind) {
          case 'table':
            return <TableBlockRenderer key={key} block={block as any} />;
          case 'chart':
            return <ChartBlockRenderer key={key} block={block as any} />;
          case 'shipment_card':
            return <ShipmentCardRenderer key={key} block={block as any} />;
          case 'share_link':
            return <ShareLinkRenderer key={key} block={block as any} />;
          case 'export':
            return <ExportBlockRenderer key={key} block={block as any} />;
          default:
            console.warn('Unknown block kind encountered:', block.kind);
            return null;
        }
      })}
    </div>
  );
});
